module.exports = __webpack_public_path__ + "img/bg-periodical.27de866e.png";